module.exports = __webpack_public_path__ + "static/media/shield-icon.297d50a2.svg";